// extracted by mini-css-extract-plugin
export default {"MedicalPanelContainer":"blya0C6X"};